import { createSlice } from '@reduxjs/toolkit';

import { initialStream } from './constants/initialStates';
import { REQUEST } from '../../constants/request';
import { INITIAL_LOADING_STATE } from '../../utils/asyncThunkRequest';

import { createStreamExtraReducers } from './asyncThunk/createStream';
import { fetchAllStreamsExtraReducers } from './asyncThunk/fetchAllStreams';
import { fetchStreamExtraReducers } from './asyncThunk/fetchStream';
import { fetchStreamListExtraReducers } from './asyncThunk/fetchStreamList';
import { updateStreamExtraReducers } from './asyncThunk/updateStream';

import { generateStreamCIDKey } from './utils/generateStreamCIDKey';

export { createStream } from './asyncThunk/createStream';
export { fetchAllStreams } from './asyncThunk/fetchAllStreams';
export { fetchStream } from './asyncThunk/fetchStream';
export { fetchStreamList } from './asyncThunk/fetchStreamList';
export { updateStream } from './asyncThunk/updateStream';

const INITIAL_STATE = {
  streams: {
    stream: {
      byId: {},
      allIds: [],
      /*
     {
       "$orgId/$streamId": {
         loading: REQUEST.idle,
         currentRequestId: undefined,
         error: null
       }
     }
     */
      request: {},
      actions: {
        create: {
          /*
          {
            "$orgId/$streamId": {
              loading: REQUEST.idle,
              currentRequestId: undefined,
              error: null
            }
          }
          */
          request: {},
        },
        update: {
          request: {},
        },
      },
    },
    allStreams: {
      layout: [],
      request: { ...INITIAL_LOADING_STATE },
    },
    byOrg: {
      allIds: {},
      request: {},
    },
  },
};

export const StreamsSlice = createSlice({
  name: 'streams',
  initialState: INITIAL_STATE,
  reducers: {
    resetStreamsSlice: () => INITIAL_STATE,
    resetStreamRequest: (state, { payload }) => {
      delete state.streams.stream.request[generateStreamCIDKey(payload.path)];
    },
    resetStreamsByOrgRequest: (state, { payload }) => {
      delete state.streams.byOrg.request[payload.path.orgId];
    },
    resetAllStreams: state => {
      state.streams.allStreams = {
        layout: [],
        request: { ...INITIAL_LOADING_STATE },
      };
    },
  },
  extraReducers: {
    ...createStreamExtraReducers,
    ...fetchAllStreamsExtraReducers,
    ...fetchStreamExtraReducers,
    ...fetchStreamListExtraReducers,
    ...updateStreamExtraReducers,
  },
});

export const {
  resetStreamsSlice,
  resetStreamRequest,
  resetStreamsByOrgRequest,
  resetAllStreams,
} = StreamsSlice.actions;

export default StreamsSlice.reducer;

export const selectorGetStream = streamCIDKey => state =>
  state.streams.streams.stream.byId[streamCIDKey] || initialStream;
export const selectorGetStreamNew = (state, streamCIDKey) =>
  state.streams.streams.stream.byId[streamCIDKey] || initialStream;
export const selectorGetStreamsByOrg = (state, orgId) =>
  state.streams.streams.byOrg.allIds[orgId] || [];
export const selectorGetStreamsByOrgRequest = (state, orgId) =>
  state.streams.streams.byOrg.request[orgId] || { ...INITIAL_LOADING_STATE };
export const selectorGetStreamRequest = (state, streamCIDKey) =>
  state.streams.streams.stream.request[streamCIDKey] || {
    ...INITIAL_LOADING_STATE,
  };
export const selectorGetStreamAllIds = state =>
  state.streams.streams.stream.allIds;
export const selectorAllStreams = state =>
  state.streams.streams.allStreams.layout || [];
export const selectorAllStreamsLoadingState = state =>
  state.streams.streams.allStreams.request.loading || REQUEST.idle;
export const selectorGetStreams = state => state.streams.streams;
export const selectorGetStreamProfilePicture = (state, streamCIDKey) =>
  state.streams.streams.stream.byId[streamCIDKey]?.metadata?.profilePicUrl;
